import { render } from "./FormTip.vue?vue&type=template&id=34169058"
import script from "./FormTip.vue?vue&type=script&lang=js"
export * from "./FormTip.vue?vue&type=script&lang=js"

import "./FormTip.vue?vue&type=style&index=0&id=34169058&lang=css"
script.render = render

export default script